import React from 'react';
import Header from './Components/Header';
import Meme from './Components/Meme';
// import './App.css';

function App() {
  return (
    <div className="App">
      <Header />
      <Meme />
    </div>
  );
}

export default App;
